import { pushToGA, pushToPixel } from "../services/sendEvent";

export const fireLeadTierPixelEvent = (fbEventLabel: string) => {
	// Push to Pixel
	pushToPixel({
		eventLabel: fbEventLabel,
	}, true);

	pushToGA({
		eventLabel: fbEventLabel,
	});
};
